// Profili social ufficiali — usati da Footer e landing
export const INSTAGRAM_URL = "https://www.instagram.com/lobiettivoimmobiliare/";
export const FACEBOOK_URL = "https://www.facebook.com/lobiettivoimmobiliare";
